export const calculateNpsScore = (promoter, detractor, total) =>
  ((promoter - detractor) / total).toFixed(1) * 100;
